import React, { useState } from 'react'
import { f } from '../../Common/Utils/Floats'
import { DocumentUnitTypes } from '@af-create/Document/_stores/DocumentStore'
import { DELAYED_INPUT_DELAY_MS, DOCUMENT_DATA_DPI, PIXEL_TO_CM } from '@af-create/_config/Consts'
import { TextField } from '@mui/material'

export type Props = {
	label?: React.ReactNode;
	onChange?: Function;
	onWheel?: Function;
	type?: string;
	value?: string;
	min?: number,
	max?: number,
	step?: number;
	className?: string;
	useUnits?: boolean;
	units?: string;
	variant?: "standard"|"outlined"|"filled"
} & {dispatch?:any}

export default function DelayedTextInput(props: Props) {
	const [valueState, setValueState] = React.useState(props.value)
	const [applyTimer, setApplyTimer] = React.useState(null)
	const [round, setRound] = useState(false)

	const get_new_timeout = () => {
		if (applyTimer) clearTimeout(applyTimer)
		return setTimeout(() => {
			props.onChange(+valueState)

			// Reset the state to the prop. Might be overriden by a new render, but in some cases
			// when the state change doesn't result in a prop change, we want to keep the real (prop) value
			// For example, setting a value above a max limit (usually min/max is handled in the reducer) will not change
			// the prop, so it won't trigger a re-render, so we need to manually go back to that.
			setValueState(props.value)
		}, DELAYED_INPUT_DELAY_MS)
	}

	React.useEffect(() => {
		let cb = () => {
			if (applyTimer) clearTimeout(applyTimer)
		}

		if(valueState == props.value) return cb
		
		setApplyTimer(get_new_timeout())
		return cb
	}, [valueState])

	React.useEffect(() => {
		setValueState(props.value)
	}, [props.value])

	const toUnits = (value:string) => {
		if(props.useUnits && props.units) {
			if(props.units == DocumentUnitTypes.Inches) value = String(Number(value) / DOCUMENT_DATA_DPI)
			else if (props.units == DocumentUnitTypes.Centimeters) value = String(Number(value) / PIXEL_TO_CM)
		}
		return f(Number(value), 1000);
	}

	const formatValue = (value: string) => {
		let pixelValue = value;

		if(props.useUnits && props.units) {
			if(props.units == DocumentUnitTypes.Inches) {
				pixelValue = String(Number(value) * DOCUMENT_DATA_DPI);
			} else if (props.units == DocumentUnitTypes.Centimeters) {
				pixelValue = String(Number(value) * PIXEL_TO_CM);
			}
		}

		return pixelValue
	}

	const onChangeLocal = (e:React.ChangeEvent<HTMLInputElement>) => {
		setValueState(formatValue(e.target.value))
	}

	const stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	const getStep = () => {
		let step = props.step || 1;
		if(props.useUnits){
			if(props.units == DocumentUnitTypes.Inches) step = 1/4;
			if(props.units == DocumentUnitTypes.Centimeters) step = 0.5;
		}
		return step;
	}

	let {onChange, value, useUnits, units, step, onWheel, dispatch, ...rest} = props;

	let v = toUnits(valueState)
	if(props.type == 'number' && props.useUnits){
		if (round) {
			if(props.type == 'number' && props.useUnits){
				if(props.units == DocumentUnitTypes.Inches) v = f(v)
				else if (props.units == DocumentUnitTypes.Centimeters) v = f(v, 10)
				else v = f(v, 1)
			}
		}
		else v = f(v, 100000)
	}

	return <TextField
		className={props.className}
		variant={props.variant || "filled"}
		label={rest.label || ""}
		onMouseDown={stopPropagation}
		onChange={(e:React.ChangeEvent<HTMLInputElement>) => onChangeLocal(e)}
		value={v}
		inputProps={{
			step: getStep(),
			onFocus: () => setRound(false),
			onBlur: () => setRound(true),
			...rest
		}}
	/>
}